import * as React from 'react';
import { debounce } from 'framework/utils/debounce';

/**
 * Custom hook for detecting mobile screen sizes
 * @param breakpoint - The pixel width to consider as mobile (default: 767px)
 * @returns boolean indicating if the current screen width is mobile
 */
export const useMobileDetection = (breakpoint: number = 767): boolean => {
  const checker = () => {
    if (!window?.matchMedia) return false;
    const isPortrait: boolean = window?.matchMedia("(orientation: portrait)")?.matches;
    return window.innerWidth <= breakpoint || (window.innerWidth <= 900 && isPortrait);
  };

  const [isMobile, setIsMobile] = React.useState(() => {
    if (typeof window !== 'undefined') {
      return checker();
    }
    return false;
  });

  React.useEffect(() => {
    const checkMobile = debounce(() => {
      setIsMobile(checker());
    }, 150);
    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, [breakpoint]);

  return isMobile;
};
